import * as R from 'ramda';

export default function EditMasterProductDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  vmDataService
) {
  const vm = this;
  vm.newMasterProduct = R.clone($scope.editMasterProductDialogVM.masterProduct);
  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleAddMasterProductFormSubmit = handleAddMasterProductFormSubmit;
  _activate();

  function _activate() {
    loaderService.showViewLoader = false;
  }

  function handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editMasterProductDialog);
  }

  function handleAddMasterProductFormSubmit() {
    _saveMasterProduct();
  }

  function _saveMasterProduct() {
    const dfdSave = $q.defer();

    if ($scope.vmaEditMasterProductForm.$valid) {
      loaderService.showViewLoader = true;
      vmDataService.saveMasterProduct(
        vm.newMasterProduct
      ).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the Master Product.');
        } else {
          alerts.success('The Master Product has been saved successfully.');

          // TODO: Refactor this to use new method of refreshing persisted objects via newMasterProduct
          $rootScope.$broadcast('refreshVMAMasterVendor', {
            masterVendorId: vm.newMasterProduct.masterVendorId
          });

          loaderService.showViewLoader = false;
          ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editMasterProductDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }
}

EditMasterProductDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'alerts',
  'ssDialogService',
  'loaderService',

  'vmDataService',
];
